import { getDriverLocations } from './getDriverLocations';
import { setSelectedDriverLocation } from './setSelectedDriverLocation';
import { resetSelectedDriverLocation } from './resetSelectedDriverLocation';
import { resetDriverLocations } from './resetDriverLocations';
import { getDriverFuelAssignmentsCards } from './getDriverFuelAssignmentsCards';
import { getDriverFilteredFuelAssignments } from './getDriverFilteredFuelAssignments';
import { addDriverFuelAssignment } from './addDriverFuelAssignment';
import { getDriverFuelAssignments } from './getDriverFuelAssignments';
import { resetDriverFuelAssignments } from './resetDriverFuelAssignments';
import { getDriverFuelAssignment } from './getDriverFuelAssignment';
import { resetAddingDriverFuelAssignmentStatus } from './resetAddingDriverFuelAssignmentStatus';
import { setSelectedDriverFuelAssignment } from './setSelectedDriverFuelAssignment';
import { deleteDriverFuelAssignment } from './deleteDriverFuelAssignment';
import { resetDeletingDriverFuelAssignmentStatus } from './resetDeletingDriverFuelAssignmentStatus';

export const driverOperations = {
  getDriverLocations,
  setSelectedDriverLocation,
  resetSelectedDriverLocation,
  resetDriverLocations,
  addDriverFuelAssignment,
  getDriverFuelAssignmentsCards,
  getDriverFilteredFuelAssignments,
  getDriverFuelAssignments,
  resetDriverFuelAssignments,
  getDriverFuelAssignment,
  resetAddingDriverFuelAssignmentStatus,
  setSelectedDriverFuelAssignment,
  deleteDriverFuelAssignment,
  resetDeletingDriverFuelAssignmentStatus
};
